import ShopArticlesListByCategoryResourcePagingResultModel from '../../generated/types/model/resource/ShopArticlesListByCategoryResourcePagingResultModel';

export default class ShopArticlesListByCategoryResourcePagingResultViewModel extends ShopArticlesListByCategoryResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
